import { createContext, useContext, useState, useCallback } from "react";
import { T, MODULE_I18N } from "./translations";
import { MEMBER_T } from "./translations_members";

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("vav-lang") || "fr");

  const setLang = useCallback((code) => {
    localStorage.setItem("vav-lang", code);
    setLangState(code);
  }, []);

  const t = useCallback((path) => {
    const lookup = (dict) => path.split(".").reduce((acc, k) => (acc && acc[k] !== undefined ? acc[k] : undefined), dict);
    const dict = MEMBER_T[lang] || MEMBER_T.fr;
    let value = lookup(dict);
    if (value === undefined) value = lookup(MEMBER_T.fr);
    if (value === undefined) value = lookup(T[lang] || T.fr);
    if (value === undefined) value = lookup(T.fr);
    return value !== undefined ? value : path;
  }, [lang]);

  const moduleText = useCallback((id, field, fallback) => {
    const entry = (MODULE_I18N[lang] || {})[id];
    return entry?.[field] || fallback;
  }, [lang]);

  return (
    <I18nContext.Provider value={{ lang, setLang, t, moduleText }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  return useContext(I18nContext);
}
